"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var http_1 = require("./http");

var endpoint = '/v5/data';

function default_1(credentials, from, to, resolution, expression, fixed, baseUUID) {
  var params = {
    from: Math.floor(from.getTime() / 1000),
    to: Math.floor(to.getTime() / 1000),
    resolution: resolution,
    expression: JSON.stringify(expression),
    fixed: fixed
  };

  if (baseUUID != null) {
    params.uuid = baseUUID.string();
  }

  return http_1.authorizedHTTP(credentials).get(endpoint, {
    params: params
  }).then(function (resp) {
    return resp.data;
  });
}

exports.default = default_1;